import React from 'react';
import clsx from 'clsx';
import {
  useOrderedStickyIds,
  usePersistedStickies,
} from 'views/EMR/Sticky/stores/stickyNotesStore';
import StickyCard from 'views/EMR/Sticky/components/StickyCard';

type Part = 'root' | 'list' | 'empty';

type Props = {
  classes?: Partial<Record<Part, string>>;
};

export default function StickyList({ classes }: Props) {
  const orderIds = useOrderedStickyIds();
  const persistedById = usePersistedStickies();

  return orderIds.length > 0 ? (
    <div
      className={clsx(
        'flex flex-col gap-2 overflow-auto p-4',
        classes?.root,
        classes?.list,
      )}
    >
      {orderIds.map((stickyId) => {
        const sticky = persistedById[stickyId];
        return (
          <StickyCard
            key={sticky?.uniqueId || stickyId}
            stickyId={stickyId}
          />
        );
      })}
    </div>
  ) : (
    <div
      className={clsx(
        'flex flex-auto justify-center items-center h-full text-gray-500 text-sm',
        classes?.empty,
      )}
    >
      No Stickies
    </div>
  );
}
